var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _rect, _path5, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuienLoHace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.44183,
    cy: 6.50836,
    rx: 5.60517,
    ry: 5.74017,
    fill: "#2A363B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2314,
    cy: 6.50836,
    rx: 5.60517,
    ry: 5.74017,
    fill: "#2A363B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.83667 18.7493C0.83667 17.0924 2.17982 15.7493 3.83667 15.7493H10.071C11.7279 15.7493 13.071 17.0924 13.071 18.7493V33.3228H0.83667V18.7493Z",
    fill: "#2A363B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6023 18.7493C23.6023 17.0924 24.9454 15.7493 26.6023 15.7493H32.8367C34.4935 15.7493 35.8367 17.0924 35.8367 18.7493V33.3228H23.6023V18.7493Z",
    fill: "#2A363B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44735 18.7213L2.96631 23.7524L9.44735 28.6101M4.39319 23.7524H32.8047M27.8103 18.7213L33.6799 23.7524L27.8103 28.6101",
    stroke: "#2A363B",
    strokeWidth: 1.49205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44735 18.7213L2.96631 23.7524L9.44735 28.6101",
    stroke: "white",
    strokeWidth: 1.49205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.18457,
    y: 23.0553,
    width: 8.88647,
    height: 1.43774,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2726 18.7213L33.7537 23.7524L27.2726 28.6101",
    stroke: "white",
    strokeWidth: 1.49205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.88647,
    height: 1.43774,
    transform: "matrix(-1 0 0 1 32.5354 23.0553)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuienLoHace);
export default __webpack_public_path__ + "static/media/quien-lo-hace.ea6054f49626150ad4f530a4b08d6877.svg";
export { ForwardRef as ReactComponent };